<template>
  <div id="app">
    <div id="header" class="container">
      <nav class="navbar navbar-expand-lg navbar-light" style="background-color: #fff;">
          <router-link class="navbar-brand" to="/"><img src="/mdkl-logo.svg" style="height:50px;" /></router-link>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <router-link to="/" class="nav-link">Home</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/careers" class="nav-link">Careers</router-link>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Brands
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                        <router-link class="dropdown-item" to="/brands/the-coffee-club">THE COFFEE CLUB</router-link>
                        <router-link class="dropdown-item" to="/brands/coffee-hit">COFFEE HIT</router-link>
                        <router-link class="dropdown-item" to="/brands/veneziano">VENEZIANO</router-link>
                    </div>
                </li>
                <li class="nav-item">
                    <router-link to="/contact" class="nav-link">Contact</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/policies" class="nav-link">Policies</router-link>
                </li>
            </ul>
          </div>
      </nav>
    </div>

    <router-view/>

    <footer>
        <div class="container text-center">
            <span class="align-middle">
                <small>&copy; 2026 - Minor DKL Food Group</small>
            </span>
        </div>
    </footer>
  </div>
</template>

<script>
import { Collapse } from 'bootstrap'

export default {
  name: 'App',
  watch: {
    // Close the mobile navbar after navigating to a new route.
    // (We can't use Bootstrap's data-bs-toggle="collapse" on the links
    // because its preventDefault blocks vue-router navigation.)
    $route () {
      const menu = document.getElementById('navbarNavDropdown')
      if (menu && menu.classList.contains('show')) {
        Collapse.getOrCreateInstance(menu, { toggle: false }).hide()
      }
    }
  }
}
</script>

<style lang="scss">
  p, h2, li, small {
      font-family: 'Montserrat', sans-serif;
  }

  h1 {
      font-family: 'Raleway', sans-serif;
  }

  h1 {
      font-size: 26px;
      margin-bottom: 25px;
      color: #7d7d7e;
  }

  h2 {
      font-size: 16px;
      font-weight: bold;
      text-transform: uppercase;
  }

  #header {
      margin-top: 15px;
      margin-bottom: 15px;
  }

  .banner-image {
      display: block;
      max-width: 1320px;
      margin: 0 auto 35px;
  }

  .navbar {
      padding: 0;
  }

  .nav-item {
      margin:15px;
  }

  .nav-link {
      text-transform: uppercase;
  }

  footer {
      min-height: 35px;
      margin-top: 25px;
      /* background-color: #7d7d7e; */
      color: #bfbebf;
  }

      footer p {
          margin-bottom:0;
      }
</style>
